import {
  ApacHotelsComponent,
  useApacHotelsStyles,
} from "@apac/components/hotels";
import { useModuleBEM } from "@b2bportal/core-themes";
import { useI18nContext } from "@hopper-b2b/i18n";
import {
  type CheckInPoliciesSectionComponentProps,
  useCheckInPolicies,
} from "@tenant/hotels";
import { Dialog, DialogClose, DialogContent, DialogTrigger } from "@tenant/ui";
import clsx from "clsx";
import defaultStyles from "./styles.module.scss";

export const CheckInPoliciesSection: React.FC<
  CheckInPoliciesSectionComponentProps
> = (props) => {
  const COMPONENT_KEY = ApacHotelsComponent.CheckInPoliciesSection;
  const styles = useApacHotelsStyles(COMPONENT_KEY, defaultStyles);
  const [block, cn] = useModuleBEM(styles, COMPONENT_KEY);

  const { t } = useI18nContext();

  const {
    context: { checkInPolicies },
    handlers,
    text: { readMore },
  } = useCheckInPolicies(props);

  if (checkInPolicies == null || checkInPolicies?.length === 0) {
    return null;
  }

  return (
    <div className={clsx(block, props.className)}>
      {checkInPolicies?.map(({ title, text }, policyIdx) => {
        if (text === "") {
          return null;
        }

        const content = handlers.cleanPolicy(text).map((item, index) => (
          <div key={index} className={cn("policy-item")}>
            {item}
          </div>
        ));

        return (
          <div
            className={cn("policy", { "not-first": policyIdx > 0 })}
            key={title}
          >
            <span className={cn("title")}>{title}</span>
            <div className={cn("policy-content")}>{content}</div>
            <Dialog>
              <DialogTrigger className={cn("read-more")}>
                {readMore}
              </DialogTrigger>

              <DialogContent
                title={title}
                bottomFixedContent={
                  <DialogClose className={cn("close-button")}>
                    <span>{t("close.button")}</span>
                  </DialogClose>
                }
              >
                <div className={cn("dialog-content")}>{content}</div>
              </DialogContent>
            </Dialog>
          </div>
        );
      })}
    </div>
  );
};
